import { Badge } from "react-bootstrap";
import { Case } from "../../../../models";
import { useEffect, useMemo, useState, KeyboardEvent } from "react";
import { useAccountQuery, useTerritoryQuery } from "../../../../queries";
import { getHoursSinceTOD, getTimeOfDeathBgColor } from "../../../../helper-functions";
import { Icon, fas } from "../../../../component-library";

export interface ReferralRowProps {
    case: Case;
    onClick: () => void;
}

export function ReferralRow({ case: _case, onClick }: Readonly<ReferralRowProps>) {
    const {
        listQuery: { data: territories },
    } = useTerritoryQuery();
    const {
        patientFirstName,
        patientLastName,
        timeOfDeathUtc,
        overallStatus,
        referringOrganizationId,
        number,
        territoryId,
    } = _case.referral ?? {};
    const {
        detailQuery: { data: account },
    } = useAccountQuery({ id: referringOrganizationId });

    const territory = territories?.find((t) => t.id === territoryId);

    const [hoursSinceTOD, setHoursSinceTOD] = useState<number | undefined>(getHoursSinceTOD(timeOfDeathUtc));

    useEffect(() => {
        const interval = setInterval(() => {
            setHoursSinceTOD(getHoursSinceTOD(timeOfDeathUtc));
        }, 60000);
        return () => clearInterval(interval);
    }, [timeOfDeathUtc]);

    const onKeyDown = (e: KeyboardEvent<HTMLTableRowElement>) => {
        if (e.key === "Enter") {
            onClick();
        }
    };

    const todBackground = useMemo(() => getTimeOfDeathBgColor(hoursSinceTOD), [hoursSinceTOD]);

    return (
        <tr className={`referral-row clickable ${todBackground}`} onClick={onClick} tabIndex={0} onKeyDown={onKeyDown}>
            <td>
                <Badge bg={todBackground} className={todBackground == "warning" ? "text-dark" : ""}>
                    {hoursSinceTOD ?? "?"}
                </Badge>
            </td>
            <td>{number}</td>
            <td className="text-nowrap fw-bold">
                {patientFirstName} {patientLastName}
            </td>
            <td>{overallStatus || "New Referral"}</td>
            <td>{account?.name}</td>
            <td>{territory?.label ?? territory?.name}</td>
            <td>
                {_case.hasFlaggedForms && (
                    <Icon
                        icon={fas.faFlag}
                        className="text-danger"
                        title="This referral has flagged forms"
                        aria-label="This referral has flagged forms"
                    />
                )}
            </td>
        </tr>
    );
}
